/**
 * Copyright (C) Firstlight Media. All rights reserved.
 * All information contained herein is and remains the property of Firstlight Media.
 * The intellectual and technical concepts contained herein are proprietary
 * to Firstlight Media. Dissemination of this information or reproduction
 * of this material is strictly forbidden unless prior written permission
 * is obtained from Firstlight Media.
 */

/**
 * Represents supported max resolution on the streaming device
 */
export enum Resolution {
  /**
   * Represents HD resolution
   */
  HD = 'HD',

  /**
   * Represents Full HD resolution
   */
  FHD = 'FHD',

  /**
   * Represents 2K resolution
   */
  '2K' = '2K',

  /**
   * Represents 4K resolution
   */
  '4K' = '4K',

  /**
   * Represents 8K resolution
   */
  '8K' = '8K',
}
